import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "block-2" }
const _hoisted_2 = { class: "info-row" }
const _hoisted_3 = { class: "info-group" }
const _hoisted_4 = {
  class: "column-display-container",
  ref: "topColumnContainer"
}
const _hoisted_5 = ["draggable", "onDragstart", "onDragover", "onDrop"]
const _hoisted_6 = { class: "value-box overflow-indicator" }
const _hoisted_7 = { class: "type-row" }
const _hoisted_8 = { class: "info-group-2" }
const _hoisted_9 = { class: "type-container" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "type-text" }
const _hoisted_12 = {
  key: 0,
  class: "missingValue"
}
const _hoisted_13 = { class: "option-text" }
const _hoisted_14 = {
  key: 1,
  class: "missingValue"
}
const _hoisted_15 = { class: "option-text" }
const _hoisted_16 = {
  key: 2,
  class: "missingValue"
}
const _hoisted_17 = { class: "option-text" }
const _hoisted_18 = {
  key: 3,
  class: "parameter-type"
}
const _hoisted_19 = {
  key: 4,
  class: "unchange-value"
}
const _hoisted_20 = {
  key: 5,
  class: "parameter-name difference-parameter-name"
}
const _hoisted_21 = {
  key: 6,
  class: "differenceRange difference-range"
}
const _hoisted_22 = { class: "range-separator" }
const _hoisted_23 = {
  key: 7,
  class: "missingValue"
}
const _hoisted_24 = {
  key: 8,
  class: "differenceRange"
}
const _hoisted_25 = { class: "range-separator" }
const _hoisted_26 = {
  key: 9,
  class: "parameter-name"
}
const _hoisted_27 = {
  key: 10,
  class: "differenceRange"
}
const _hoisted_28 = { class: "range-separator" }
const _hoisted_29 = {
  key: 11,
  class: "parameter-name"
}
const _hoisted_30 = {
  key: 12,
  class: "differenceRange"
}
const _hoisted_31 = { class: "range-separator" }
const _hoisted_32 = {
  key: 13,
  class: "parameter-name"
}
const _hoisted_33 = {
  key: 14,
  class: "unchange-value"
}
const _hoisted_34 = {
  key: 15,
  class: "parameter-name"
}
const _hoisted_35 = { class: "option-text" }
const _hoisted_36 = {
  key: 16,
  class: "parameter-name-two sequence-parameter-name"
}
const _hoisted_37 = { class: "option-text" }
const _hoisted_38 = {
  key: 17,
  class: "parameter-name-lookup"
}
const _hoisted_39 = { class: "lookup-label" }
const _hoisted_40 = { class: "option-text" }
const _hoisted_41 = {
  key: 18,
  class: "multiple-condition-container"
}
const _hoisted_42 = { class: "multiple-condition-label" }
const _hoisted_43 = { class: "select-tag-container" }
const _hoisted_44 = {
  key: 0,
  class: "select-tag select-tag--more"
}
const _hoisted_45 = { class: "option-with-checkbox" }
const _hoisted_46 = { class: "option-text" }
const _hoisted_47 = {
  key: 0,
  class: "differenceRange"
}
const _hoisted_48 = { class: "range-separator" }
const _hoisted_49 = { class: "option-with-checkbox" }
const _hoisted_50 = { class: "option-text" }
const _hoisted_51 = {
  key: 19,
  class: "parameter-name-lookup"
}
const _hoisted_52 = { class: "option-text" }
const _hoisted_53 = { class: "value-row-2" }
const _hoisted_54 = {
  key: 0,
  class: "missingValue"
}
const _hoisted_55 = {
  key: 1,
  class: "parameter-name-two sequence-parameter-name"
}
const _hoisted_56 = {
  key: 2,
  class: "parameter-name"
}
const _hoisted_57 = { class: "range-label-text" }
const _hoisted_58 = {
  key: 3,
  class: "differenceRange"
}
const _hoisted_59 = { class: "range-separator" }
const _hoisted_60 = {
  key: 4,
  class: "parameter-name-lookup"
}
const _hoisted_61 = { class: "lookup-label" }
const _hoisted_62 = { class: "option-text" }
const _hoisted_63 = {
  key: 5,
  class: "parameter-name-lookup"
}
const _hoisted_64 = { class: "option-text" }
const _hoisted_65 = { class: "submit-button-container" }
const _hoisted_66 = {
  key: 1,
  class: "default-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.localCard)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "label" }, "Column", -1)),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleColumnNames(
                _ctx.displayColumnNames,
                'top'
              ), (col, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: _normalizeClass([
                'value-box',
                {
                  'value-box--draggable': _ctx.canDragColumns,
                  'value-box--drag-over':
                    _ctx.canDragColumns && _ctx.dragOverColumnIndex === index,
                },
              ]),
                    ref_for: true,
                    ref: `topColumnItem-${index}`,
                    draggable: _ctx.canDragColumns,
                    onDragstart: ($event: any) => (_ctx.onColumnChipDragStart(index)),
                    onDragover: _withModifiers(($event: any) => (_ctx.onColumnChipDragOver(index)), ["prevent"]),
                    onDrop: _withModifiers(($event: any) => (_ctx.onColumnChipDrop(index)), ["prevent"]),
                    onDragend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetColumnDragState && _ctx.resetColumnDragState(...args)))
                  }, _toDisplayString(col), 43, _hoisted_5))
                }), 128)),
                (_ctx.getHiddenColumnCount(_ctx.displayColumnNames, 'top') > 0)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      placement: "top",
                      "show-after": 2000,
                      content: 
                _ctx.getHiddenColumnNames(_ctx.displayColumnNames, 'top').join(', ')
              ,
                      "popper-class": "custom-tooltip"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, " +" + _toDisplayString(_ctx.getHiddenColumnCount(_ctx.displayColumnNames, "top")), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true)
              ], 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "label" }, "Rule Type", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.getTypeIcon(_ctx.localCard.relationType),
                  alt: _ctx.localCard.relationType,
                  class: "type-icon"
                }, null, 8, _hoisted_10),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getDisplayRuleType(_ctx.localCard.relationType)), 1)
              ])
            ])
          ]),
          _cache[68] || (_cache[68] = _createElementVNode("div", { class: "paramater-row" }, [
            _createElementVNode("div", { class: "label" }, "Paramaters")
          ], -1)),
          _createElementVNode("div", {
            class: _normalizeClass([
          'value-row',
          {
            'value-row--multiple':
              _ctx.localCard?.relationType === 'MultipleCondition',
          },
        ])
          }, [
            (_ctx.localCard.relationType === 'Missing')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[36] || (_cache[36] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[37] || (_cache[37] = _createTextVNode(" MissingDetectFlag ")),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.missingDetectFlag,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localCard.ruleValue.missingDetectFlag) = $event)),
                    placeholder: "Select value",
                    placement: "bottom"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: true, label: 'true' },
                { value: false, label: 'false' },
              ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Duplicate')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[38] || (_cache[38] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[39] || (_cache[39] = _createTextVNode(" DuplicateDetectFlag ")),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.duplicateDetectFlag,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localCard.ruleValue.duplicateDetectFlag) = $event)),
                    placeholder: "Select value",
                    placement: "bottom"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: true, label: 'true' },
                { value: false, label: 'false' },
              ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'MultipleDuplicate')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[40] || (_cache[40] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[41] || (_cache[41] = _createTextVNode(" DuplicateDetectFlag ")),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localCard.ruleValue) = $event)),
                    placeholder: "Select value",
                    placement: "bottom"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: true, label: 'true' },
                { value: false, label: 'false' },
              ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Type')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[42] || (_cache[42] = [
                  _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1),
                  _createTextVNode(" ColumnType ")
                ])))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Type')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.localCard.ruleValue), 1))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Difference')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[44] || (_cache[44] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: 'Difference',
                    disabled: 'Difference'.length <= _ctx.getMaxLabelLength(),
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                      _createElementVNode("span", null, "Difference", -1)
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Difference')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.start,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localCard.ruleValue.start) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.startInclusive,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localCard.ruleValue.startInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[0],
                    disabled: _ctx.localCard.columnName[0].length <= 10,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.localCard.columnName[0]), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.endInclusive,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localCard.ruleValue.endInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.end,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localCard.ruleValue.end) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'relativeDifference')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[45] || (_cache[45] = [
                  _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1),
                  _createTextVNode(" Relative Difference ")
                ])))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'relativeDifference')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.start,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localCard.ruleValue.start) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.startInclusive,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localCard.ruleValue.startInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[0],
                    disabled: _ctx.localCard.columnName[0].length <= 10,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.localCard.columnName[0]), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.endInclusive,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localCard.ruleValue.endInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.end,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localCard.ruleValue.end) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Range')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _cache[47] || (_cache[47] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: 'Range',
                    disabled: 'Range'.length <= _ctx.getMaxLabelLength(),
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                      _createElementVNode("span", { class: "range-label-text" }, "Range", -1)
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Range')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.start,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localCard.ruleValue.start) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.startInclusive,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localCard.ruleValue.startInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[0],
                    disabled: _ctx.localCard.columnName[0].length <= 10,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.localCard.columnName[0]), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.endInclusive,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.localCard.ruleValue.endInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.end,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.localCard.ruleValue.end) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Outlier')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[49] || (_cache[49] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: 'Outlier',
                    disabled: 'Outlier'.length <= _ctx.getMaxLabelLength(),
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                      _createElementVNode("span", { class: "range-label-text" }, "Outlier", -1)
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Outlier')
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.start,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.localCard.ruleValue.start) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.startInclusive,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.localCard.ruleValue.startInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[0],
                    disabled: _ctx.localCard.columnName[0].length <= 10,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.localCard.columnName[0]), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.endInclusive,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.localCard.ruleValue.endInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localCard.ruleValue.end,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.localCard.ruleValue.end) = $event)),
                    precision: 2,
                    controls: false,
                    class: "range-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Distribution')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[50] || (_cache[50] = [
                  _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1),
                  _createTextVNode(" Distribution ")
                ])))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Distribution')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.localCard.ruleValue), 1))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Compare')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _cache[51] || (_cache[51] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[52] || (_cache[52] = _createTextVNode(" Relation ")),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.localCard.ruleValue) = $event)),
                    placeholder: "Select relation",
                    placement: "bottom"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: 'smaller', label: 'smaller' },
                { value: 'smaller_equal', label: 'smaller_equal' },
                { value: 'equal', label: 'equal' },
                { value: 'not_equal', label: 'not equal' },
                { value: 'larger', label: 'larger' },
                { value: 'larger_equal', label: 'larger_equal' },
              ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Sequence')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _cache[53] || (_cache[53] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[54] || (_cache[54] = _createTextVNode(" CurrentValue ")),
                  _createVNode(_component_el_select, {
                    id: "sequenceValue",
                    modelValue: _ctx.localSelectedSequenceValue,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.localSelectedSequenceValue) = $event)),
                    onChange: _ctx.updateAllowedNext,
                    placeholder: "",
                    placement: "bottom",
                    class: "sequence-select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sequenceRules[String(_ctx.localCard.columnName)] ||
              [], (sequence) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: sequence.value,
                          value: sequence.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(sequence.value), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Logical and condition')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[55] || (_cache[55] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[0],
                    disabled: _ctx.localCard.columnName[0].length <= _ctx.getMaxLabelLength(),
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.truncateColumnName(_ctx.localCard.columnName[0])), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  (_ctx.localCard.relationType === 'Logical and condition')
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        id: "conditionValue",
                        modelValue: _ctx.localSelectedConditionValue,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.localSelectedConditionValue) = $event)),
                        onChange: _ctx.updateConstraintValue,
                        placement: "bottom",
                        placeholder: "",
                        class: "lookup-select"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionRules[
                _ctx.localCard.columnName.join('+')
              ], (condition) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: condition.conditionValue,
                              value: condition.conditionValue
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_40, _toDisplayString(condition.conditionValue), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'MultipleCondition')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMultipleConditionRows(), (row, rowIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: rowIndex,
                      class: "multiple-condition-row"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (column, colIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: colIndex,
                          class: _normalizeClass(["multiple-condition-item", { 'placeholder-item': column.type === 'placeholder' }])
                        }, [
                          (column.type !== 'placeholder')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[56] || (_cache[56] = _createElementVNode("img", {
                                  src: "/cardpanel_icon/parameter-arrow.svg",
                                  class: "parameter-arrow"
                                }, null, -1)),
                                _createVNode(_component_el_tooltip, {
                                  effect: "dark",
                                  placement: "top",
                                  content: column.name,
                                  disabled: !column.needsTooltip,
                                  "popper-class": "custom-tooltip"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(column.displayName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["content", "disabled"]),
                                (
                    column.type.startsWith('condition') &&
                    column.conditionIndex !== undefined
                  )
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 0,
                                      modelValue: 
                    _ctx.localSelectedMultiConditionValues[column.conditionIndex]
                  ,
                                      "onUpdate:modelValue": ($event: any) => ((
                    _ctx.localSelectedMultiConditionValues[column.conditionIndex]
                  ) = $event),
                                      onChange: ($event: any) => (_ctx.handleMultiConditionChange(column.conditionIndex)),
                                      placement: "bottom",
                                      placeholder: "",
                                      class: "multiple-condition-select",
                                      ref_for: true,
                                      ref: `conditionSelect_${column.conditionIndex}`
                                    }, _createSlots({
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUniqueConditionValues(
                      column.conditionIndex
                    ), (condition) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: condition,
                                            value: condition
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_45, [
                                                _createVNode(_component_el_checkbox, {
                                                  "model-value": 
                          _ctx.isConditionValueChecked(
                            column.conditionIndex!,
                            condition
                          )
                        ,
                                                  onChange: 
                          (checked) =>
                            _ctx.toggleConditionValueCheckbox(
                              column.conditionIndex!,
                              condition,
                              checked
                            )
                        ,
                                                  onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                                                }, null, 8, ["model-value", "onChange"]),
                                                _createElementVNode("span", _hoisted_46, _toDisplayString(condition), 1)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, [
                                      (
                      _ctx.getConditionSelectionList(column.conditionIndex!).length
                    )
                                        ? {
                                            name: "prefix",
                                            fn: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_43, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleConditionTags(
                          column.conditionIndex!
                        ), (tag) => {
                                                  return (_openBlock(), _createElementBlock("span", {
                                                    key: tag,
                                                    class: "select-tag"
                                                  }, _toDisplayString(tag), 1))
                                                }), 128)),
                                                (_ctx.getHiddenConditionTagCount(column.conditionIndex!) > 0)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, " +" + _toDisplayString(_ctx.getHiddenConditionTagCount(column.conditionIndex!)), 1))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            key: "0"
                                          }
                                        : undefined
                                    ]), 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                  : (column.type === 'constraint')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (column.constraintType === 'RangeBased')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                              _createVNode(_component_el_input_number, {
                                                modelValue: _ctx.multiConstraintRangeValues[column.constraintIndex!].start,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.multiConstraintRangeValues[column.constraintIndex!].start) = $event),
                                                controls: false,
                                                precision: 2,
                                                class: "range-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                              _createVNode(_component_el_select, {
                                                modelValue: _ctx.multiConstraintRangeValues[column.constraintIndex!].startInclusive,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.multiConstraintRangeValues[column.constraintIndex!].startInclusive) = $event),
                                                class: "range-operator",
                                                "popper-append-to-body": false
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_option, {
                                                    value: true,
                                                    label: "≤"
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    value: false,
                                                    label: "<"
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.getConstraintColumnNameByIndex(column.constraintIndex!)), 1),
                                              _createVNode(_component_el_select, {
                                                modelValue: _ctx.multiConstraintRangeValues[column.constraintIndex!].endInclusive,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.multiConstraintRangeValues[column.constraintIndex!].endInclusive) = $event),
                                                class: "range-operator",
                                                "popper-append-to-body": false
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_option, {
                                                    value: true,
                                                    label: "≤"
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    value: false,
                                                    label: "<"
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                              _createVNode(_component_el_input_number, {
                                                modelValue: _ctx.multiConstraintRangeValues[column.constraintIndex!].end,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.multiConstraintRangeValues[column.constraintIndex!].end) = $event),
                                                controls: false,
                                                precision: 2,
                                                class: "range-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: _ctx.multiConstraintEqualityValues[column.constraintIndex!],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.multiConstraintEqualityValues[column.constraintIndex!]) = $event),
                                              multiple: "",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": "",
                                              placeholder: "Select constraint values",
                                              placement: "bottom",
                                              class: "multiple-condition-select",
                                              ref_for: true,
                                              ref: `constraintSelect_${column.constraintIndex}`,
                                              "max-collapse-tags": 
                      _ctx.getMaxConstraintCollapseTags(column.constraintIndex!)
                    ,
                                              onChange: _ctx.handleMultiConstraintChange
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableMultiConstraintValues(
                        column.constraintIndex!
                      ), (value) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: value,
                                                    label: value,
                                                    value: value,
                                                    class: "truncate-option"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_49, [
                                                        _createVNode(_component_el_checkbox, {
                                                          "model-value": 
                            _ctx.isConstraintValueChecked(
                              column.constraintIndex!,
                              value
                            )
                          ,
                                                          onChange: 
                            (checked) =>
                              _ctx.toggleConstraintValueCheckbox(
                                column.constraintIndex!,
                                value,
                                checked
                              )
                          ,
                                                          onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                                                        }, null, 8, ["model-value", "onChange"]),
                                                        _createElementVNode("span", _hoisted_50, _toDisplayString(value), 1)
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "max-collapse-tags", "onChange"]))
                                      ], 64))
                                    : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Lookup')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _cache[57] || (_cache[57] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[58] || (_cache[58] = _createElementVNode("span", { class: "lookup-label" }, "ParentValue", -1)),
                  (_ctx.localCard.relationType === 'Lookup')
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: _ctx.localSelectedParentValue,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.localSelectedParentValue) = $event)),
                        placeholder: "Select parent value",
                        placement: "bottom",
                        onChange: _ctx.updateChildValues,
                        class: "lookup-select"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableParentValues, (value) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: value,
                              label: value,
                              value: value
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_52, _toDisplayString(value), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_53, [
            (_ctx.localCard.relationType === 'Missing')
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _cache[59] || (_cache[59] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[60] || (_cache[60] = _createTextVNode(" SpecialMissingValues ")),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localCard.ruleValue.specialMissingValueList,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.localCard.ruleValue.specialMissingValueList) = $event)),
                    multiple: "",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    placeholder: "input special missing values",
                    onChange: _ctx.handleSpecialMissingValuesChange,
                    "collapse-tags": false,
                    "collapse-tags-tooltip": false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localCard.ruleValue.specialMissingValueList, (value) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: value,
                          value: value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Sequence')
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _cache[61] || (_cache[61] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[62] || (_cache[62] = _createTextVNode(" allowed_next ")),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localSelectedAllowedNext,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.localSelectedAllowedNext) = $event)),
                    multiple: "",
                    "collapse-tags": true,
                    "collapse-tags-tooltip": true,
                    "max-collapse-tags": "2",
                    placeholder: "Select allowed_next values",
                    placement: "bottom",
                    class: "sequence-select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSequenceValues, (value) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: value,
                          value: value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.localCard.relationType === 'Logical and condition' &&
            _ctx.localCard.constraintType?.[0] === 'RangeBased'
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _cache[63] || (_cache[63] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[1],
                    disabled: _ctx.localCard.columnName[1].length <= _ctx.getMaxLabelLength(),
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.truncateColumnName(_ctx.localCard.columnName[1])), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.localCard.relationType === 'Logical and condition' &&
            _ctx.localCard.constraintType?.[0] === 'RangeBased'
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localConstraintValue_Range.start,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.localConstraintValue_Range.start) = $event)),
                    controls: false,
                    precision: 2,
                    class: "range-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localConstraintValue_Range.startInclusive,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.localConstraintValue_Range.startInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[1],
                    disabled: _ctx.localCard.columnName[1].length <= 10,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.localCard.columnName[1]), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localConstraintValue_Range.endInclusive,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.localConstraintValue_Range.endInclusive) = $event)),
                    class: "range-operator",
                    "popper-append-to-body": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: true,
                        label: "≤"
                      }),
                      _createVNode(_component_el_option, {
                        value: false,
                        label: "<"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localConstraintValue_Range.end,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.localConstraintValue_Range.end) = $event)),
                    controls: false,
                    precision: 2,
                    class: "range-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.localCard.relationType === 'Logical and condition' &&
            _ctx.localCard.constraintType?.[0] === 'EqualityBased'
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _cache[64] || (_cache[64] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _ctx.localCard.columnName[1],
                    disabled: _ctx.localCard.columnName[1].length <= _ctx.getMaxLabelLength(),
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.truncateColumnName(_ctx.localCard.columnName[1])), 1)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localConstraintValue_Equality,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.localConstraintValue_Equality) = $event)),
                    multiple: "",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    placeholder: "Select constraint values",
                    placement: "bottom",
                    class: "lookup-select",
                    "max-collapse-tags": 
              _ctx.getMaxCollapseTags(_ctx.localConstraintValue_Equality)
            
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableConstraintValues, (value) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: value,
                          value: value,
                          class: "truncate-option"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_62, _toDisplayString(value), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "max-collapse-tags"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.localCard.relationType === 'Lookup')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _cache[65] || (_cache[65] = _createElementVNode("img", {
                    src: "/cardpanel_icon/parameter-arrow.svg",
                    class: "parameter-arrow"
                  }, null, -1)),
                  _cache[66] || (_cache[66] = _createElementVNode("span", { class: "lookup-label" }, "ChildValues", -1)),
                  (_ctx.localCard.relationType === 'Lookup')
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: _ctx.localSelectedChildValues,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.localSelectedChildValues) = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        placeholder: "Select child values",
                        placement: "bottom",
                        class: "lookup-select",
                        "max-collapse-tags": _ctx.getMaxCollapseTags(_ctx.localSelectedChildValues)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPossibleChildValues, (value) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: value,
                              label: value,
                              value: value,
                              class: "truncate-option"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_64, _toDisplayString(value), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "max-collapse-tags"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _ctx.syncToBackend,
              class: "submit-button"
            }, {
              default: _withCtx(() => _cache[67] || (_cache[67] = [
                _createTextVNode(" Submit ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_66, "Please Choose Validation Card"))
  ]))
}